(() => {
  const root = document.documentElement;
  if (root.dataset.mhCatalogViewReady) return;
  root.dataset.mhCatalogViewReady = 'true';
  const storageKey = 'mh:catalog-view';
  const phone = window.matchMedia('(max-width: 749px)');
  const normalize = (value) => value === 'list' ? 'list' : 'grid';

  const sync = () => {
    const view = normalize(root.dataset.mhCatalogView);
    document.querySelectorAll('[data-mh-catalog] [data-mh-view-controls]').forEach((controls) => {
      controls.querySelectorAll('[data-mh-view]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.mhView === view));
      });
      controls.hidden = !phone.matches;
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.('[data-mh-catalog] [data-mh-view]');
    if (!button || !phone.matches) return;
    const controls = button.closest('[data-mh-view-controls]');
    const top = controls.getBoundingClientRect().top;
    const view = normalize(button.dataset.mhView);
    root.dataset.mhCatalogView = view;
    try { localStorage.setItem(storageKey, view); } catch (error) {}
    sync();
    const offset = controls.getBoundingClientRect().top - top;
    if (Math.abs(offset) > 1) window.scrollBy({ top: offset, behavior: 'instant' });
  });

  const restore = () => {
    try { root.dataset.mhCatalogView = normalize(localStorage.getItem(storageKey)); } catch (error) {}
    sync();
  };

  document.addEventListener('mh:idle', (event) => {
    if (event.detail?.source === 'category-filter') sync();
  });
  document.addEventListener('shopify:section:load', sync);
  window.addEventListener('pageshow', restore);
  window.addEventListener('storage', (event) => {
    if (event.key === storageKey || event.key === null) restore();
  });
  phone.addEventListener('change', sync);
  sync();
})();
